import { NgModule } from '@angular/core';
import { RouterModule, type Routes } from '@angular/router';
import { ContractLayoutComponent } from '../../../layouts/contract-layout/contract-layout.component';
import { ListComponent } from './pages/list/list.component';
import { DetailsComponent } from './components/details/details.component';
import { BlogLayoutComponent } from '../../../layouts/blog-layout/blog-layout.component';
export const routes: Routes = [
  {
    path: '',
    component: BlogLayoutComponent,
    children: [
      {
        path: '',
        data: {
          pageInfoSEOKey: 'blog',
        },
        component: ListComponent,
      },
      {
        path: ':id',
        component: DetailsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlogsRoutingModule { }
